import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

const INITIAL_STATE = {
  trigger: false,
  switchRoleRequest: true,
  switchRoleRouter: false,
  announcementLoading: true,
  announcements: [],
  auctionSellersByStatus: {},
}

export const useUserStore = create((set) => ({
  ...INITIAL_STATE,

  // Called when the session ends so the next account starts clean.
  reset: () => set(INITIAL_STATE),

  toggleTrigger: () => set((state) => ({ trigger: !state.trigger })),
  requesToSwitchRole: ({ switchRoleRequest }) => set({ switchRoleRequest }),
  requesToSwitchRoleRouter: ({ status }) => set({ switchRoleRouter: status }),
  setAnnouncements: ({ announcements }) =>
    set({ announcements: announcements || [], announcementLoading: false }),
  setAuctionSellersByStatus: (data) => set({ auctionSellersByStatus: data }),
}))

// Drop-in replacement for the retired UserContext's `useUser()`.
export const useUser = () =>
  useUserStore(
    useShallow((state) => ({
      trigger: state.trigger,
      switchRoleRequest: state.switchRoleRequest,
      switchRoleRouter: state.switchRoleRouter,
      announcementLoading: state.announcementLoading,
      announcements: state.announcements,
      auctionSellersByStatus: state.auctionSellersByStatus,
      toggleTrigger: state.toggleTrigger,
      requesToSwitchRole: state.requesToSwitchRole,
      requesToSwitchRoleRouter: state.requesToSwitchRoleRouter,
      setAnnouncements: state.setAnnouncements,
      setAuctionSellersByStatus: state.setAuctionSellersByStatus,
    })),
  )
